import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { fetchPurchaserDashboard } from '../../store/slices/dashboardSlice';
import { StatCard } from './StatCard';
import { useNavigate } from 'react-router-dom';

export const PurchaserDashboard = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { purchaserDashboard, loading, error } = useSelector(
    (state: RootState) => state.dashboard
  );

  useEffect(() => {
    dispatch(fetchPurchaserDashboard());
  }, [dispatch]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-gray-600 dark:text-gray-400">Yükleniyor...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
        <p className="text-red-700 dark:text-red-300">{error}</p>
      </div>
    );
  }

  if (!purchaserDashboard) {
    return null;
  }

  return (
    <div className="space-y-6 animate-fadeIn">
      {/* Acil İşlemler */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="animate-slideUp" style={{ animationDelay: '0ms' }}>
          <StatCard
            title="Teklif Oluşturulması Gereken Talepler"
            value={purchaserDashboard.approvedRequestsForQuote}
            icon={<i className="fas fa-exclamation-triangle"></i>}
            color="red"
            onClick={() => navigate('/draft-quote')}
          />
        </div>
        <div className="animate-slideUp" style={{ animationDelay: '100ms' }}>
          <StatCard
            title="Değerlendirme Bekleyen Talepler"
            value={purchaserDashboard.readyToEvaluateRequests}
            icon={<i className="fas fa-hourglass-half"></i>}
            color="yellow"
            onClick={() => navigate('/quote-evaluation')}
          />
        </div>
      </div>

      {/* Teklif İstatistikleri */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="animate-slideUp" style={{ animationDelay: '200ms' }}>
          <StatCard
            title="Aktif Teklifler"
            value={purchaserDashboard.activeQuotes}
            icon={<i className="fas fa-file-contract"></i>}
            color="blue"
            onClick={() => navigate('/quote-tracking')}
          />
        </div>
        <div className="animate-slideUp" style={{ animationDelay: '300ms' }}>
          <StatCard
            title="Müzakere Bekleyen"
            value={purchaserDashboard.negotiationQuoteItems}
            icon={<i className="fas fa-handshake"></i>}
            color="orange"
            onClick={() => navigate('/negotiation-quote')}
          />
        </div>
        <div className="animate-slideUp" style={{ animationDelay: '400ms' }}>
          <StatCard
            title="Awarded Teklifler"
            value={purchaserDashboard.awardedQuoteItems}
            icon={<i className="fas fa-trophy"></i>}
            color="green"
          />
        </div>
      </div>

      {/* Sipariş Durumu */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="animate-slideUp" style={{ animationDelay: '500ms' }}>
          <StatCard
            title="Bekleyen Siparişler"
            value={purchaserDashboard.waitingPurchaseOrders}
            icon={<i className="fas fa-shopping-cart"></i>}
            color="yellow"
            onClick={() => navigate('/purchase-order')}
          />
        </div>
        <div className="animate-slideUp" style={{ animationDelay: '600ms' }}>
          <StatCard
            title="Senkronize Siparişler"
            value={purchaserDashboard.syncedPurchaseOrders}
            icon={<i className="fas fa-check-circle"></i>}
            color="green"
          />
        </div>
      </div>

      {/* Son Teklifler */}
      <div className="grid grid-cols-1">
        <div className="animate-slideUp" style={{ animationDelay: '700ms' }}>
          <StatCard
            title="Son 7 Gün Teklifler"
            value={purchaserDashboard.recentQuotes}
            icon={<i className="fas fa-calendar-alt"></i>}
            color="blue"
            onClick={() => navigate('/quote-tracking')}
          />
        </div>
      </div>
    </div>
  );
};
